import { queryOptions, useQuery } from '@tanstack/react-query'

import { ApiGateway } from '@/modules/api/api.gateway'
import { ConfigRepository } from '@/modules/config/core/config.repository'
import { ConfigService } from '@/modules/config/core/config.service'
import { ConfigResponseDto } from '@/modules/config/core/config.types'
import { staleTime } from '@/shared/constants/stale-time'

const apiGateway = new ApiGateway()
const configRepository = new ConfigRepository(apiGateway)
const configService = new ConfigService(configRepository)

const configQueryOptions = queryOptions({
  queryFn: () => configService.getAll(),
  queryKey: ['config'],
  staleTime: staleTime.ONE_DAY,
})

const useConfig = <T>({
  select,
}: {
  select?: (data: ConfigResponseDto) => T
} = {}) => {
  return useQuery({ ...configQueryOptions, select })
}

export { useConfig }
